import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  addAccountPostCall, fetchAccountInfoForAgent, fetchUserAccountInfo
} from "../../../../shared/hooks/useFetchAccountInfo";
import { dwLogging, generateSessionId } from "../../../../shared/hooks/useFetchLogin";
import API_URLS from "../../Utils/axr";
import { errorConditionGTM, sendEventGTMLog } from "../../Utils/googleTags";
import store, { RootState } from "../store";
import { addressQualification } from "../../../../shared/hooks/useFetchCompleteAddress";
import { updateAddressQualificationSlice } from "./addressQualification";
import { setHeaders } from "./brightspeedToken";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import DwLogutil from "../../Utils/DwLogutil";
import moment from "moment";
import { sendEventLog } from "../../Utils/app-log";
import {
  isApiRetryGuardEnabled,
  shouldSkipFailedOutApiFetch,
  shouldStopApiRetry,
  logApiRetryCapDwLog,
  resolveSessionId,
} from "../../Utils/utils";
// import useBrightspeedUser from "../../hooks/useUser";

type userDetailsForAgentFlow = {
  ban: string;
  addressId?: string
}

export enum flowType {
  "loginFlow",
  "forget_username",
  "silent_login",
  "silent_registration",
  "forget_password",
  "registration", // user availabe in c60 but not exist in azure
  "account_lock",
  "login_with_recaptcha",
  "set_password_first_time", // it's only for new placed order is uder coming from email link for setting a password
  "set_password_first_time_with_catpcha",
  "login"
}

type authPhaseType = "prelogin" | "postlogin";

type userInitialStateType = {
  acp: string;
  acpModalStatus: boolean;
  data: any;
  loading: boolean;
  error: any;
  token: string;
  jwtToken: string;
  refreshToken: string;
  authPhase: authPhaseType;
  rootToken: string;
  clientId: string;
  changePassClientId: string;
  principalName: string;
  accountEnabled: string;
  companyName: string;
  otp: string;
  forgotPassPrefMethod: string;
  canUserResetPass: boolean;
  emailOnlyForRegister: string;
  hashEmailOnlyForRegister: string;
  phoneNoHash: string;
  accountIdOnlyForRegister: string;
  sessionId: string;
  sessionLoading: boolean;
  contactNumber: string;
  isCaptchaChecked: boolean;
  isCaptchaLoading: boolean;
  isGetAccountDetailsLoading: boolean;
  forgotEmailId: string;
  appDownloadModalHideAsDoNotShowAgain: boolean;
  reOpenAppDownloadModal: boolean;
  emailBeforeLogin: string;
  userNameBeforeLogin: string;
  isCtlUserBeforeLogin: boolean;
  isUserSettingPassFromEmailLink: boolean;
  isSilentLogin: boolean;
  originalPrimaryEmail: string;
  forgotPassSelectedValue: any;
  autoPayEnrolled: boolean;
  manageAccount: any;
  userCustomerId: string;
  logoutClickedValue: boolean;
  userData: any;
  userSwitchingStatus: boolean;
  userLocked: string;
  listOfUserLoder: boolean;
  listOfUserError: any;
  loginUserBan: string;
  loginUserAddressId: string;
  forgetPassPayloadForResendOTP: any;
  registerUserInAZ: any;
  logedinUserName: string;
  forgetUserNameContactNumber: string;
  flowType: flowType;
  isGrandFather?:boolean;
  migrationDslEligible: boolean;
  migrationVoiceEligible: boolean;
  migrationNoVoiceEligible: boolean;
  isUserOnJeopardy: boolean;
  accountDetailsFetched: boolean;
  accountDetailsRetryCount: number;
  userListFetched: boolean;
  userListRetryCount: number;
  createPinLoading: boolean;
  createPinError: string | null;
};

const initialState: userInitialStateType = {
  acp: "no",
  acpModalStatus: false,
  data: null,
  loading: false,
  error: null,
  token: localStorage?.getItem("token") || "",
  jwtToken: "",
  refreshToken: localStorage?.getItem("iamrt") || "",
  authPhase: localStorage?.getItem("iamrt") ? "postlogin" : "prelogin",
  rootToken: localStorage?.getItem("rootToken") || "",
  clientId: "",
  changePassClientId: "",
  principalName: "",
  accountEnabled: "",
  companyName: "",
  otp: "",
  forgotPassPrefMethod: "",
  canUserResetPass: false,
  emailOnlyForRegister: "",
  hashEmailOnlyForRegister: "",
  phoneNoHash: "",
  accountIdOnlyForRegister: "",
  sessionId: sessionStorage?.getItem("sessionId") || "",
  contactNumber: "",
  isCaptchaChecked: false,
  isCaptchaLoading: false,
  isGetAccountDetailsLoading: false,
  isCtlUserBeforeLogin: false,
  forgotEmailId: "",
  sessionLoading: false,
  appDownloadModalHideAsDoNotShowAgain: localStorage.getItem(
    "appDownloadModalHideAsDoNotShowAgain"
  )
    ? true
    : false,
  reOpenAppDownloadModal: false,
  emailBeforeLogin: "",
  userNameBeforeLogin: "",
  isUserSettingPassFromEmailLink: false,
  isSilentLogin: false,
  originalPrimaryEmail: localStorage.getItem("originalPrimaryEmail") || "",
  userCustomerId: localStorage.getItem("custId") || "",
  userData: null,
  forgotPassSelectedValue: "",
  manageAccount: "",
  userSwitchingStatus: false,
  userLocked: localStorage.getItem("lockedUser") || "",
  listOfUserLoder: false,
  listOfUserError: null,
  autoPayEnrolled: false,
  logoutClickedValue: false,
  loginUserBan: localStorage.getItem("loginUserBan") || "",
  loginUserAddressId: localStorage.getItem("loginUserAddressId") || "",
  forgetPassPayloadForResendOTP: null,
  registerUserInAZ: null,
  logedinUserName:"",
  forgetUserNameContactNumber: "",
  flowType: localStorage.getItem("flowType") ? parseInt(localStorage.getItem("flowType") || "0") : flowType.loginFlow,
  isGrandFather:false,
  migrationDslEligible: false,
  migrationVoiceEligible: false,
  migrationNoVoiceEligible: false,
  isUserOnJeopardy: false,
  accountDetailsFetched: false,
  accountDetailsRetryCount: 0,
  userListFetched: false,
  userListRetryCount: 0,
  createPinLoading: false,
  createPinError: null,
};

const c3States = ["AR", "KS", "LA", "MO", "OK", "TX", "NC", "WI"];

const suspendedStatuses = ["suspended", "paymentpastdue", "payment past due"];

const normalizeStatus = (status?: string) =>
  status?.toLowerCase()?.replace(/\s+/g, " ")?.trim() || "";

const hasManageAccountList = (manageAccount: unknown) =>
  Array.isArray(manageAccount) && manageAccount.length > 0;

const resolveCreatePinErrorMessage = (error: any): string =>
  error?.response?.data?.message || error?.message || "Unable to create security PIN";

export const createSecurityPin = createAsyncThunk(
  "user/createSecurityPin",
  async (pin: string, { rejectWithValue }) => {
    try {
      const reduxStore = store.getState() as any;
      const headers = reduxStore?.brightspeedToken?.headers;
      const accountPinExists = !!reduxStore?.user?.data?.accountPinExists;
      const payload = {
        "authPin": pin,
        "actionType": accountPinExists ? "PIN_Reset" : "PIN_Creation"
      };    
      const response = await addAccountPostCall(
        {
          "": [API_URLS?.createPin],
        },
        payload,
        headers
      );

      return response?.data;
    } catch (error: any) {
      return rejectWithValue(resolveCreatePinErrorMessage(error));
    }
  }
);

export const getUserDetails : any = createAsyncThunk(
  "user/Details",
  async (email: string) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const ban = reduxStore?.user?.loginUserBan;
      const addId = reduxStore?.user?.loginUserAddressId;
      const user = reduxStore?.user?.data
      const response = await fetchUserAccountInfo(
        // const response = await fetchAccountInfo(
        // {
        //   [API_URLS?.accountManagementUrl]: `account-details-user-secure`,
        // },
        // {
        //   username: email.toLowerCase(),
        //   token: reduxStore?.user?.refreshToken,
        // },
        {
          [API_URLS?.accountManagementUrlAuth as string]: `get-account-details?ban=${ban}&addressId=${addId}`, //?ban=300851067&addressId=237798650
        },

        {
          ...headers,
          "access-token": reduxStore?.brightspeedToken?.headers?.['access-token'],
        }
      );

     
      
      const serviceAdd = response?.data?.addresses?.find(
          (addr: any) => addr?.addressType === "ServiceAddress"
        ) || "";        
      const isMigrated = response?.data?.migratedAccount?.toUpperCase() === "Y" ? true : false;
      const isCtl = headers?.siteId?.toLowerCase() === "ctl" ? true : false;
      response.data.customerSince = moment(response?.data?.customerSince).format("MM/DD/YYYY");
      if(isMigrated){ localStorage?.setItem("migratedCTLUser","true")}
      if (isMigrated && serviceAdd && c3States?.includes(serviceAdd?.state?.toUpperCase())) {
        DwLogutil({email: response?.data?.email,stepName: EC_DW_LOGGING_STEPS?.c3_user_loggedin});
        sendEventLog(EC_DW_LOGGING_STEPS?.c3_user_loggedin, {
          c3_user_loggedin: EC_DW_LOGGING_STEPS?.c3_user_loggedin
        });
        sendEventGTMLog(EC_DW_LOGGING_STEPS?.c3_user_loggedin, headers?.siteId);
      }
      localStorage.removeItem("EMBARGO_BANNER_FOR_CTL")
      if(response?.data?.billingSchedules && Array.isArray(response?.data?.billingSchedules) && response?.data?.billingSchedules?.length){
        if(response?.data?.billingSchedules[0]["c3"]==="Yes"){
          localStorage.setItem("EMBARGO_BANNER_FOR_CTL","true")
        }
      }

      if (serviceAdd && (isMigrated || isCtl)) { 
        DwLogutil({email: response?.data?.email,stepName: EC_DW_LOGGING_STEPS?.CTL_User_With_State?.replace('<VALUE>', serviceAdd?.state)}) 
      }

      if(!(response?.data?.billingSystem)){
        DwLogutil({email: response?.data?.email,stepName:EC_DW_LOGGING_STEPS.billing_system_null})
      }

      if(!(reduxStore?.user?.companyName)){
        if(isMigrated){
           store?.dispatch(addCompanyName("Century Link"));
        }else if(response?.data?.billingSystem && response?.data?.billingSystem==="BRIM" &&  response?.data?.network?.toLowerCase()=== "copper"){
          store?.dispatch(addCompanyName("ctl"));
        }else{
          store?.dispatch(addCompanyName("bs"));
        }
      }
      // for jeopardy status will be is Past payment due
      // response.data.currentStatus = "Past payment due";
      // response.data.currentStatus = "Suspended";
      // response.data.suspendReason = "Payment Failed" / "Non Pay";
     
      const normalizedCurrentStatus = normalizeStatus(response?.data?.currentStatus);
      if (
        (response?.data?.suspendReason === "Payment Failed" || response?.data?.suspendReason === "Non Pay") &&
         !["active", "inactive"].includes(normalizedCurrentStatus) || suspendedStatuses.includes(normalizedCurrentStatus)
      ) {
        response.data.isSuspended = true;
      }
      const postPaidFiberUser = (response?.data?.network?.toUpperCase() === "XGSPON" && response?.data?.billingType?.toUpperCase() === "POSTPAID") ? true : false;
        const userStatus = (response?.data?.currentStatus?.toLowerCase()?.includes("suspended") && postPaidFiberUser) ? EC_DW_LOGGING_STEPS.user_with_suspended_postpaid_fiber :
        response?.data?.currentStatus?.toLowerCase()?.includes("suspended") 
         ? EC_DW_LOGGING_STEPS.user_with_suspended :
        (response?.data?.currentStatus?.toLowerCase()?.trim()?.includes("pastpaymentdue") && postPaidFiberUser) ?   EC_DW_LOGGING_STEPS.user_with_jeopardy_postpaid_fiber 
        : response?.data?.currentStatus?.toLowerCase()?.trim()?.includes("pastpaymentdue") && EC_DW_LOGGING_STEPS.user_with_Jeopardy;  DwLogutil({email: response?.data?.email,stepName: userStatus});
        sendEventLog(userStatus,{userStatus:userStatus})
        sendEventGTMLog(userStatus, headers?.siteId);
      
      if (response?.data?.email) {
        response.data.suspendStartDate =
          response?.data?.suspendStartDate?.trim() || "";
        response.data.suspendEndDate =
          response?.data?.suspendEndDate?.trim() || "";
      }
      if(response?.data?.billingType){
        response.data.billingType = response.data.billingType.toLowerCase()
      }
      if(response?.data?.billingSystem && (response?.data?.billingSystem==="BRIM" && (headers?.siteId?.toLowerCase() !=="ctl" || headers?.siteId?.toLowerCase() !=="4glte"))){

        store?.dispatch(
          setHeaders({
            ...headers,
            siteId: headers?.siteId?.toLowerCase(),
          })
        );
        localStorage.setItem("headersSiteId", headers?.siteId?.toLowerCase());

        dwLogging(
          {
            "": API_URLS?.dwLoggingUrl,
          },
          {
            sessionId: headers?.sessionId || sessionStorage?.getItem("sessionId") || "",
            stepName: EC_DW_LOGGING_STEPS.BRIM_With_None_CTL,
            cta: "Success",
            customerType: headers?.siteId?.toLowerCase() || "",
            billingType : response?.data?.billingType?.toLowerCase() || "",
          },
          headers
        );
      }  
      store?.dispatch(
        setHeaders({
          ...headers,
          billingType: response?.data?.billingType || "",
          billingSystem: response?.data?.billingSystem || "",
          networkType: response?.data?.networkType || ""
        })
      );
      DwLogutil({email: response?.data?.email,stepName: EC_DW_LOGGING_STEPS?.getaccount_by_ban_API_success}) 
      DwLogutil({email: response?.data?.email,stepName: EC_DW_LOGGING_STEPS?.B2C_login_success});
      return response.data;
    } catch (error) {
      DwLogutil({stepName: EC_DW_LOGGING_STEPS?.getaccount_by_ban_API_failed}) 
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const userState = (getState() as RootState).user;
      if (userState.isGetAccountDetailsLoading) {
        return false;
      }
      // Stop infinite retry when fetch never succeeds; allow refresh when data exists
      if (shouldSkipFailedOutApiFetch(!!userState.data, userState.accountDetailsFetched)) {
        return false;
      }
      return true;
    },
  }
);

export const getUserDetailsForAgent = createAsyncThunk(
  "user/Details-agent",
  async (userDetails: userDetailsForAgentFlow) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      let API_URL_FOR_AGENT = `${API_URLS?.userInfoByAccIdUrl}?accountID=${userDetails?.ban}`
      if(userDetails?.addressId) {
        API_URL_FOR_AGENT += `&addressId=${userDetails?.addressId}`
      }
      

      // New Headers added on 2026-01-07

      const response = await fetchAccountInfoForAgent(
        {
          "": API_URL_FOR_AGENT,
        },
        headers
      );
      if (
        response.data?.collections?.customer?.length &&
        response.data?.collections?.customer[0]?.billingAccountNumber
      ) {
        const  serviceNetworkType = response.data?.collections?.customer[0]?.addresses?.find(
            (addr:any) => addr.addressType === "ServiceAddress"
        )?.networkType
        
   
        store?.dispatch(
                  setHeaders({
                    ...headers,
                    siteId: response.data?.collections?.customer[0]?.siteId,
                    networkType:serviceNetworkType,
                    billingSystem: response.data?.collections?.customer[0]?.billingSystem,
                    billingType:response.data?.collections?.customer[0]?.billingType
              })
          );
        return response.data?.collections?.customer[0];
        
      } else {
        throw new Error("Invalid user details");
      }
    } catch (error) {
      throw error;
    }
  }
);
export const getUserDetailsInfo = createAsyncThunk(
  "user/Details-info",
  async (customerId: string) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const fetchCIDRequestId = sessionStorage.getItem("fetchCIDRequestId");
      const requestHeaders = {
        ...headers,
        ...(fetchCIDRequestId ? { "x-usr-eml": fetchCIDRequestId } : {}),
      };
      const response = await fetchUserAccountInfo(
        {
          [API_URLS?.accountManagementUrl as string]: `getUserAccountDetails?customerId=${customerId}`,
        },
        requestHeaders
      );

      // for jeopardy status will be is Past payment due
      // response.data.currentStatus = "Past payment due";
      // response.data.currentStatus = "Suspended";
      // response.data.suspendReason = "Payment Failed" / "Non Pay";
      let paymentFailedSuspend = response?.data?.find((item: any) => item?.suspendReason?.toLowerCase()?.trim()?.includes("paymentfailed"))
      let nonpaySuspend = response?.data?.find(( item: any )=> item?.suspendReason?.toLowerCase()?.trim()?.includes("nonpay"))
      let userCurrentStatus = response?.data?.find(( item: any )=> item?.currentStatus)
      let suspendedUser = response?.data?.find(( item: any )=> item?.currentStatus?.toLowerCase()?.includes("suspended"))
      let jeopardyUser = response?.data?.find(( item: any )=> item?.currentStatus?.toLowerCase()?.trim()?.includes("pastpaymentdue"))
       
      if 
        ( (paymentFailedSuspend?.suspendReason) || (nonpaySuspend?.suspendReason) &&
        !["Active", "Inactive"]?.includes(userCurrentStatus?.currentStatus) && (jeopardyUser || suspendedUser)
      ) {
        response.data.isSuspended = true;
        const userStatus = suspendedUser?.currentStatus ? EC_DW_LOGGING_STEPS.user_with_suspended : jeopardyUser?.currentStatus && EC_DW_LOGGING_STEPS.user_with_Jeopardy;
        DwLogutil({email: response?.data?.email,stepName: userStatus});
        sendEventLog(userStatus,{userStatus:userStatus})
        sendEventGTMLog(userStatus, headers?.siteId);
      }
       if (response) {
        const value = response?.data?.length > 1 ? true : false
        if (value) {
        DwLogutil({email:response?.data?.email, stepName: EC_DW_LOGGING_STEPS.multi_account_user, error: JSON.stringify(value) })
        sendEventLog(EC_DW_LOGGING_STEPS.multi_account_user, {
          multi_account_user : EC_DW_LOGGING_STEPS.multi_account_user
        });
        sendEventGTMLog(EC_DW_LOGGING_STEPS?.multi_account_user, headers?.siteId);
      }
      };
      if(response?.data?.billingType){
        response.data.billingType = response.data.billingType.toLowerCase()
      }
      response.data.customerSince = moment(response?.data?.customerSince).format("MM/DD/YYYY");
      if(response?.data?.length === 0) {
        DwLogutil({
          stepName: EC_DW_LOGGING_STEPS.userNotFountWith_cust_ID_Not_Found,
          error: "User not found in c360 with CustID"
        })
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const userState = (getState() as RootState).user;
      if (userState.listOfUserLoder) {
        return false;
      }
      // Stop infinite retry when list fetch settled without accounts; allow refresh when list exists
      if (
        isApiRetryGuardEnabled() &&
        userState.userListFetched &&
        !hasManageAccountList(userState.manageAccount)
      ) {
        return false;
      }
      return true;
    },
  }
);

export const getAccountDetailsInfo = createAsyncThunk(
  "user/account-info",
  async (dataParam: string) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const cName = reduxStore?.user?.companyName;
      const user = reduxStore?.user?.data
      const response = await fetchUserAccountInfo(
        {
          [API_URLS?.accountManagementUrlAuth as string]: `get-account-details?${dataParam}`, //?ban=300851067&addressId=237798650
        },
        {
          ...headers,
          "access-token": reduxStore?.brightspeedToken?.headers?.['access-token'],
        }
      );
      

      if (response?.data?.billingSystem && (response?.data?.billingSystem==="BRIM" && (headers?.siteId?.toLowerCase() !=="ctl" || headers?.siteId?.toLowerCase() !=="4glte") )){
        
        store?.dispatch(
          setHeaders({
            ...headers,
            siteId: headers?.siteId?.toLowerCase(),
          })
        );
        localStorage.setItem("headersSiteId", headers?.siteId?.toLowerCase());
      
        dwLogging(
          {
            "": API_URLS?.dwLoggingUrl,
          },
          {
            sessionId: headers?.sessionId || sessionStorage?.getItem("sessionId") || "",
            stepName: EC_DW_LOGGING_STEPS.BRIM_With_None_CTL,
            cta: "Success",
            customerType: headers?.siteId?.toLowerCase() || "",
            billingType : response?.data?.billingType?.toLowerCase() || "",
          },
          headers
        );
        store?.dispatch(
          setHeaders({
            ...headers,
            billingType: response?.data?.billingType || "",
            billingSystem: response?.data?.billingSystem || "",
            networkType: response?.data?.networkType || ""
          })
      );
      }
      // below API call is for siteId when user switch the account then after user detail in All other APi it should pass as header
      const serviceAdd =
        response?.data?.addresses?.find(
          (addr: any) => addr?.addressType === "ServiceAddress"
        ) || "";   
      const isCtl = headers?.siteId?.toLowerCase() === "ctl" ? true : false;
      const isMigrated = response?.data?.migratedAccount?.toUpperCase() === "Y" ? true : false;
      response.data.customerSince = moment(response?.data?.customerSince).format("MM/DD/YYYY");
      if (isMigrated && serviceAdd && c3States?.includes(serviceAdd?.state?.toUpperCase())) {
        DwLogutil({email: response?.data?.email,stepName: EC_DW_LOGGING_STEPS?.c3_user_loggedin})
        sendEventLog(EC_DW_LOGGING_STEPS?.c3_user_loggedin, {
          c3_user_loggedin: EC_DW_LOGGING_STEPS?.c3_user_loggedin
        });
        sendEventGTMLog(EC_DW_LOGGING_STEPS?.c3_user_loggedin, headers?.siteId);
      }
      if (serviceAdd && (isMigrated || isCtl)) { 
        DwLogutil({email: response?.data?.email,stepName: EC_DW_LOGGING_STEPS?.CTL_User_With_State?.replace('<VALUE>', serviceAdd?.state)}) 
      }

      if(!(response?.data?.billingSystem)){
        DwLogutil({email: response?.data?.email,stepName:EC_DW_LOGGING_STEPS.billing_system_null})
      }
       if(!(reduxStore?.user?.companyName)){
        if(isMigrated && response?.data?.network?.toLowerCase()=== "copper"){
           store?.dispatch(addCompanyName("Century Link"));
        }else if(response?.data?.billingSystem && response?.data?.billingSystem==="BRIM" && response?.data?.network?.toLowerCase()=== "copper"){
          store?.dispatch(addCompanyName("ctl"));
        }else{
          store?.dispatch(addCompanyName("bs"));
        }
      }

      if (
        serviceAdd &&
        serviceAdd?.street &&
        serviceAdd?.city &&
        serviceAdd?.state &&
        serviceAdd?.addressId &&
        (!serviceAdd?.addressId?.toLowerCase()?.includes("ban")) &&
        (response?.data?.billingSystem==="BRIM" ? headers?.siteId : true))
       {

        let url=API_URLS?.addressQualificationURL;
        const addressQualificationResponse = await addressQualification(
          {
            "": `${url}?addressId=${serviceAdd?.addressId}&serviceInstanceId=${response?.data?.serviceInstanceId || ""}&existingUser=EC`,
          },
          headers
        );
        if (
          addressQualificationResponse?.status === 200
        ) {
          const addressQualificationRes = addressQualificationResponse?.data?.data 
                    ? addressQualificationResponse?.data 
                    : addressQualificationResponse  
          if (
            (["QF_QUALIFIED", "QF QUALIFIED"]?.includes(
              addressQualificationRes?.data?.entity?.brightSpeedFiberIndicator?.toUpperCase()
            ) && addressQualificationRes?.data?.entity?.instantInternet) || addressQualificationRes?.data?.entity?.siteId?.toLowerCase() === "qf-ii"
          ) {
            if(!cName) {
              store?.dispatch(addCompanyName(addressQualificationRes?.data?.entity?.instantInternet
                ? "qf-ii"
                : "qf"));
            }
            if(response?.data?.billingSystem!=="BRIM"){
            store?.dispatch(
              setHeaders({
                ...headers,
                siteId: headers?.siteId?.toLowerCase(),
              })
            );
            localStorage.setItem("headersSiteId", headers?.siteId?.toLowerCase());}
          } else if (
            ["CTL QUALIFIED", "CTL_QUALIFIED", "COPPER QUALIFIED"]?.includes(
              addressQualificationRes?.data?.entity?.brightSpeedFiberIndicator?.toUpperCase()
            )
          ) {
            if(!cName) {
              store?.dispatch(addCompanyName("ctl"));
            }
          }

          if (
            addressQualificationRes?.data?.entity?.brightSpeedFiberIndicator
          ) {
            store?.dispatch(
              updateAddressQualificationSlice({
                addressQualification: addressQualificationRes?.data,
              })
            );
          }
        }
      }

      // for jeopardy status will be is Past payment due
      // response.data.currentStatus = "Past payment due";
      // response.data.currentStatus = "Suspended";
      // response.data.suspendReason = "Payment Failed" / "Non Pay";
      const normalizedCurrentStatus = normalizeStatus(response?.data?.currentStatus);
       
      if (
        (response?.data?.suspendReason === "Payment Failed" || response?.data?.suspendReason === "Non Pay") &&
        !["active", "inactive"].includes(normalizedCurrentStatus) && suspendedStatuses.includes(normalizedCurrentStatus)
      ) {
        response.data.isSuspended = true;
      }

      if (response?.data?.email) {
        response.data.suspendStartDate =
          response?.data?.suspendStartDate?.trim() || "";
        response.data.suspendEndDate =
          response?.data?.suspendEndDate?.trim() || "";
      }
      if(response?.data?.billingType){
        response.data.billingType = response.data.billingType.toLowerCase()
      }
      // Always align billing headers with the loaded account (e.g. account switch);
      // the BRIM-only block above does not run for ZUORA and other billing systems.
      const headersAfterFlow = store.getState().brightspeedToken.headers;
      store?.dispatch(
        setHeaders({
          ...headersAfterFlow,
          billingType: response?.data?.billingType || "",
          billingSystem: response?.data?.billingSystem || "",
          networkType: response?.data?.networkType || "",
        })
      );
      DwLogutil({email: response?.data?.email,stepName: EC_DW_LOGGING_STEPS?.getaccount_by_ban_API_success}) 
      return response.data;
    } catch (error) {
      DwLogutil({stepName: EC_DW_LOGGING_STEPS?.getaccount_by_ban_API_failed}) 
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const userState = (getState() as RootState).user;
      if (userState.isGetAccountDetailsLoading) {
        return false;
      }
      // Stop infinite retry when fetch never succeeds; allow refresh when data exists
      if (shouldSkipFailedOutApiFetch(!!userState.data, userState.accountDetailsFetched)) {
        return false;
      }
      return true;
    },
  }
);

// export const getSessionId = createAsyncThunk("user/sessionId", async () => {
//   try {
//     const reduxStore = store.getState();
//     const headers = reduxStore?.brightspeedToken?.headers;
//     const response = await generateSessionId({}, headers);
//     const sessionId = response?.data?.sessionId;
//     if (!sessionId || sessionId.trim() === "") {
//       DwLogutil({stepName:EC_DW_LOGGING_STEPS.no_session_id});
//     }
//     localStorage?.setItem("sessionId", sessionId);
//     return sessionId;
//   } catch (error) {
//     DwLogutil({stepName:EC_DW_LOGGING_STEPS.no_session_id});
//     throw error;
//   }
// });


export const getSessionId = createAsyncThunk<string, void, { state: RootState }>(
  "user/sessionId",
  async () => {
    const resolvedSessionId = resolveSessionId();
    if (resolvedSessionId) {
      return resolvedSessionId;
    }

    try {
      const headers = store.getState()?.brightspeedToken?.headers;
      const response = await generateSessionId({}, headers);
      const sessionId = response?.data?.sessionId;
      if (!sessionId || sessionId.trim() === "") {
        DwLogutil({ stepName: EC_DW_LOGGING_STEPS.no_session_id });
      }
      sessionStorage.setItem("sessionId", sessionId);
      return sessionId;
    } catch (error) {
      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.no_session_id });
      throw error;
    }
  },
  {
  condition: (_, { getState }) => {
    const state = getState();
    const tokenData = state.brightspeedToken?.data;
    const accessToken = tokenData?.access_token || tokenData?.id;
    const expectedAuthorization = accessToken ? `Bearer ${accessToken}` : "";
    const currentAuthorization = state.brightspeedToken?.headers?.Authorization;
    const hasValidAuthorization =
      !!currentAuthorization &&
      !!expectedAuthorization &&
      currentAuthorization === expectedAuthorization;

    if (!hasValidAuthorization) {
      return false;
    }

    const tokenExpiresAt = state.brightspeedToken?.tokenExpiresAt;
    if (typeof tokenExpiresAt === "number" && tokenExpiresAt <= Date.now()) {
      return false;
    }

    const hasSession = !!sessionStorage?.getItem("sessionId");
    const { sessionLoading } = state.user || {};

    if (hasSession) {
      return false;
    }

    if (sessionLoading) {
      return false;
    }

    return true;
  }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAcpStatus: (state, action) => {
      state.acp = action.payload.toLowerCase();
      return state;
    },
    setGrandfather: (state, action) => {
      state.isGrandFather = action.payload
      return state;
    },
    setAcpModalStatus: (state, action) => {
      state.acpModalStatus = action.payload;
      return state;
    },
    addToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    addRootToken: (state, action) => {
      state.rootToken = action.payload;
      return state;
    },
    logoutClicked: (state, action) => {
      if (action.payload) {
        localStorage.removeItem("redirectPath");
        localStorage.removeItem("redirectPathSuspendnonpay");
        localStorage.removeItem("redirectPathVacationpause");
        localStorage.removeItem("isSuspendNonpay");
        localStorage.removeItem("isVacationPause");
        localStorage.removeItem("isMoverDeepLinkDone");
      }
      state.logoutClickedValue = action.payload;
    },
    logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("idTokenExpiry");
      localStorage.removeItem("switchedUserBAN");
      localStorage.removeItem("switchedUserAddId");
      localStorage.removeItem("iamrt");
      localStorage.removeItem("originalPrimaryEmail");
      localStorage.removeItem("alreadyShownPaymentMethodMsg");
      localStorage.removeItem("loginUserAddressId");
      localStorage.removeItem("loginUserBan");
      localStorage.removeItem("persist:getAccordionState");
      localStorage.removeItem("persist:brightspeedToken");
      localStorage.removeItem("persist:nutritionLabelContent");
      localStorage.removeItem("persist:cartSliceState");
      localStorage.removeItem("persist:repairAppointment");
      localStorage.removeItem("persist:notificationDetails");
      localStorage.removeItem("persist:findUser");
      localStorage.removeItem("persist:userAccountSlice");
      localStorage.removeItem("persist:getAppointmentSlotsData");
      localStorage.removeItem("persist:setDslMigrationPendingApiStatus");
      localStorage.removeItem("persist:getProductState");
      localStorage.removeItem("persist:preInsttallService");
      localStorage.removeItem("persist:addressQualification");
      localStorage.removeItem("persist:getMoversAppointmentTimeslots");
      localStorage.removeItem("persist:moversCartSliceState");
      localStorage.removeItem("persist:purlPayment");
      localStorage.removeItem("persist:moversInternetProductData");
      localStorage.removeItem("persist:moversVoiceProductData");
      localStorage.removeItem("persist:moversAddonProductData");
      state.data = null;
      state.error = null;
      state.loading = false;
      state.token = "";
      state.originalPrimaryEmail = "";
      state.refreshToken = "";
      state.authPhase = "prelogin";
      localStorage.removeItem("changePending");
      localStorage.removeItem("headersSiteId");
      localStorage.removeItem("custId");
      state.manageAccount = "";
      state.isUserOnJeopardy = false; // Reset jeopardy status on logout - will be set again on next login if applicable
      state.accountDetailsFetched = false;
      state.accountDetailsRetryCount = 0;
      state.userListFetched = false;
      state.userListRetryCount = 0;
    },
    addClientId: (state, action: PayloadAction<string>) => {
      state.clientId = action.payload;
    },
    removeClientId: (state) => {
      state.clientId = "";
    },
    addOTP: (state, action: PayloadAction<string>) => {
      state.otp = action.payload;
    },
    setCanUserResetPass: (state, action: PayloadAction<boolean>) => {
      state.canUserResetPass = action.payload;
    },
    setPrefMethod: (state, action: PayloadAction<string>) => {
      state.forgotPassPrefMethod = action.payload;
    },
    setContactNumber: (state, action: PayloadAction<string>) => {
      state.contactNumber = action.payload;
    },
    addChangePassClientId: (state, action: PayloadAction<string>) => {
      state.changePassClientId = action.payload;
    },
    removeChangePassClientId: (state) => {
      state.changePassClientId = "";
    },
    addPrincipalName: (state, action: PayloadAction<string>) => {
      state.principalName = action.payload;
    },
    addFirstTimeSetPasswordAccountEnabled: (
      state,
      action: PayloadAction<string>
    ) => {
      state.accountEnabled = action.payload;
    },
    addCompanyName: (state, action: PayloadAction<string>) => {
      localStorage?.setItem("companyName", action?.payload);
      state.companyName = action.payload;
    },
    removeCompanyName: (state) => {
      localStorage?.removeItem("companyName");
      state.companyName = "";
    },
    removePrincipalName: (state) => {
      state.principalName = "";
    },
    addJwtTokens: (state, action: PayloadAction<string>) => {
      state.jwtToken = action.payload;
    },
    //Making use of acccess token from token API
    addRefreshTokens: (state, action: PayloadAction<string>) => {
      state.refreshToken = action.payload;
      state.authPhase = action.payload ? "postlogin" : "prelogin";
    },
    addEmailForRegisterOnly: (state, action: PayloadAction<string>) => {
      state.emailOnlyForRegister = action.payload;
    },
    addEmailHash_ForRegisterOnly: (state, action: PayloadAction<string>) => {
      state.hashEmailOnlyForRegister = action.payload;
    },
    addPhoneNoHash: (state, action: PayloadAction<string>) => {
      state.phoneNoHash = action.payload;
    },
    addAccountIdForRegisterOnly: (state, action: PayloadAction<string>) => {
      state.accountIdOnlyForRegister = action.payload;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setIsCaptchaChecked: (state) => {
      state.isCaptchaChecked = true;
    },
    startCaptchaLoading: (state) => {
      state.isCaptchaLoading = true;
    },
    stopCaptchaLoading: (state) => {
      state.isCaptchaLoading = false;
    },
    addForgotEmailId: (state, action: PayloadAction<string>) => {
      state.forgotEmailId = action.payload;
    },
    setAppDownloadModalHideAsDoNotShowAgain: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.appDownloadModalHideAsDoNotShowAgain = action.payload;
    },
    setReOpenAppDownloadModal: (state, action: PayloadAction<boolean>) => {
      state.reOpenAppDownloadModal = action.payload;
    },
    addEmailBeforeLogin: (state, action: PayloadAction<string>) => {
      state.emailBeforeLogin = action.payload;
    },
    addUserNameBeforeLogin: (state, action: PayloadAction<string>) => {
      state.userNameBeforeLogin = action.payload;
    },
    isCtlUserBeforeLogin: (state, action: PayloadAction<boolean>) => {
      state.isCtlUserBeforeLogin = action.payload;
    },
    setIsUserSettingPassFromEmailLink: (state) => {
      state.isUserSettingPassFromEmailLink = true;
    },
    setIsSilentLogin: (state, action) => {
      state.isSilentLogin = action.payload;
    },
    setOriginalPrimaryEmail: (state, action) => {
      if (action.payload) {
        localStorage.setItem("originalPrimaryEmail", action.payload);
      } else {
        localStorage.removeItem("originalPrimaryEmail");
      }
      state.originalPrimaryEmail = action.payload;
    },
    addUserCustomerId: (state, action: PayloadAction<string>) => {
      state.userCustomerId = action.payload;
    },
    addUserDetails: (state, action: PayloadAction<any>) => {
      state.userData = action.payload;
    },
    addEmailPhoneForOtp: (state, action: PayloadAction<any>) => {
      state.forgotPassSelectedValue = action.payload;
    },
    setAutoPayEnrolled: (state, action) => {
      state.autoPayEnrolled = action.payload;
    },
    switchUserStart: (state) => {
      state.userSwitchingStatus = true;
      state.isUserOnJeopardy = false; // Reset jeopardy status on switching account - will be set again on next switch if applicable
      state.accountDetailsFetched = false;
      state.accountDetailsRetryCount = 0;
      state.userListFetched = false;
      state.userListRetryCount = 0;
    },
    switchUserStop: (state) => {
      state.userSwitchingStatus = false;
    },
    setUserLockStatus: (state, action: PayloadAction<any>) => {
      localStorage.setItem("lockedUser", action?.payload);
      state.userLocked = action?.payload;
    },
    setAddUserForRegisterAz: (state, action: PayloadAction<any>) => {
      state.registerUserInAZ = action?.payload;
    },
    updateLastLoginUserBan: (state, action: PayloadAction<string>) => {
      localStorage.setItem("loginUserBan", action?.payload);
      state.loginUserBan = action?.payload;
    },
    updateLastLoginUserAddressId: (state, action: PayloadAction<string>) => {
      localStorage.setItem("loginUserAddressId", action?.payload);
      state.loginUserAddressId = action?.payload;
    },
     setManageAccount: (state,action: PayloadAction<string>) => {
      state.manageAccount = action?.payload;
    },
    updateForgetPassPayloadForResendOTP: (
      state,
      action: PayloadAction<any>
    ) => {
      state.forgetPassPayloadForResendOTP = action?.payload;
    },
    addUserName: (state, action: PayloadAction<string>) => {
      state.logedinUserName = action.payload;
    },
    addForgetUserNameContactNumber: (state, action: PayloadAction<string>) => {
      state.forgetUserNameContactNumber = action.payload;
    },
    updateFlowType: (state, action: PayloadAction<flowType>) => {
      const flowTypeIndex: any = action.payload;
      localStorage.setItem("flowType", flowTypeIndex);
      state.flowType = action.payload;
    },
    setMigrationDslEligible: (state, action: PayloadAction<boolean>) => {
      state.migrationDslEligible = action.payload;
    },
    setMigrationVoiceEligible: (state, action: PayloadAction<boolean>) => {
      state.migrationVoiceEligible = action.payload;
    },
    setMigrationNoVoiceEligible: (state, action: PayloadAction<boolean>) => {
      state.migrationNoVoiceEligible = action.payload;
    },
    setIsUserOnJeopardy: (state, action: PayloadAction<boolean>) => {
      state.isUserOnJeopardy = action.payload;
    },
    setSecurityPin: (state, action: PayloadAction<string>) => {
      if (!state.data) {
        state.data = {};
      }
      state.data.accountPinExists = true;
      state.data.hasSecurityPin = true;
    },
    clearSession: (state) => {
      state.sessionId = "";
      state.error = null;
    },
    syncSessionId: (state, action: PayloadAction<string | undefined>) => {
      const sessionId =
        action.payload?.trim() || sessionStorage?.getItem("sessionId")?.trim() || "";
      state.sessionId = sessionId;
    },
    updateCommPrefData:(state, action) => {
      if( action?.payload?.hasOwnProperty('mrktSMSPrimaryConsentFlag')){
        state.data.preferenceCenterResponse.mrktSMSPrimaryConsentFlag = action?.payload?.mrktSMSPrimaryConsentFlag;  
      }
      if( action?.payload?.hasOwnProperty('mrktSMSSecondaryConsentFlag')){
        state.data.preferenceCenterResponse.mrktSMSSecondaryConsentFlag = action?.payload?.mrktSMSSecondaryConsentFlag;  
      }
      if( action?.payload?.hasOwnProperty('tranEMPrimaryConsentFlag')){
        state.data.preferenceCenterResponse.tranEMPrimaryConsentFlag = action?.payload?.tranEMPrimaryConsentFlag; 
      }
      if( action?.payload?.hasOwnProperty('mrktEMSecondaryConsentFlag')){
        state.data.preferenceCenterResponse.mrktEMSecondaryConsentFlag = action?.payload?.mrktEMSecondaryConsentFlag; 
      }
      if( action?.payload?.hasOwnProperty('mrktEMPrimaryConsentFlag')){
        state.data.preferenceCenterResponse.mrktEMPrimaryConsentFlag = action?.payload?.mrktEMPrimaryConsentFlag; 
      }
      /* 
      Commented for Day-3483
      if( action?.payload?.hasOwnProperty('mrktOTMSecondaryConsentFlag')){
        state.data.preferenceCenterResponse.mrktOTMSecondaryConsentFlag = action?.payload?.mrktOTMSecondaryConsentFlag; 
      }
      if( action?.payload?.hasOwnProperty('mrktOTMPrimaryConsentFlag')){
        state.data.preferenceCenterResponse.mrktOTMPrimaryConsentFlag = action?.payload?.mrktOTMPrimaryConsentFlag; 
      } */
      if( action?.payload?.hasOwnProperty('tranEMSecondaryConsentFlag')){
        state.data.preferenceCenterResponse.tranEMSecondaryConsentFlag = action?.payload?.tranEMSecondaryConsentFlag; 
      }
      if( action?.payload?.hasOwnProperty('tranSMSSecondaryConsentFlag')){
        state.data.preferenceCenterResponse.tranSMSSecondaryConsentFlag = action?.payload?.tranSMSSecondaryConsentFlag; 
      }
      if( action?.payload?.hasOwnProperty('tranSMSPrimaryConsentFlag')){
        state.data.preferenceCenterResponse.tranSMSPrimaryConsentFlag = action?.payload?.tranSMSPrimaryConsentFlag; 
      }
      
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getUserDetails.pending, (state) => {
      state.loading = true;
      state.isGetAccountDetailsLoading = true;
    });
    builder.addCase(getUserDetails.fulfilled, (state, action) => {
      state.data = action.payload;
      state.acp = action?.payload?.acp?.toLowerCase();
      state.loading = false;
      state.error = null;
      state.isGetAccountDetailsLoading = false;
      state.accountDetailsRetryCount = 0;
      state.accountDetailsFetched = true;
    });
    builder.addCase(getUserDetails.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "user details",
        action.error?.message,
        action?.type
      );
      state.data = null;
      state.loading = false;
      state.error = action.error;
      state.isGetAccountDetailsLoading = false;
      state.accountDetailsRetryCount += 1;
      if (shouldStopApiRetry(state.accountDetailsRetryCount)) {
        state.accountDetailsFetched = true;
        logApiRetryCapDwLog(
          EC_DW_LOGGING_STEPS.getaccount_by_ban_API_retry_cap,
          action.error?.message
        );
      }
    });

    builder.addCase(getUserDetailsForAgent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserDetailsForAgent.fulfilled, (state, action) => {
      state.data = action.payload;
      state.acp = action?.payload?.acp?.toLowerCase();
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getUserDetailsForAgent.rejected, (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(getSessionId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSessionId.fulfilled, (state, action) => {
      state.sessionId = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getSessionId.rejected, (state, action) => {
      state.sessionId = "";
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(getUserDetailsInfo.pending, (state) => {
      state.listOfUserLoder = true;
    });
    builder.addCase(getUserDetailsInfo.fulfilled, (state, action) => {
      state.manageAccount = action.payload;
      //state.data = action.payload;
      state.acp = action?.payload?.acp?.toLowerCase();
      state.listOfUserLoder = false;
      state.listOfUserError = null;
      state.userListRetryCount = 0;
      state.userListFetched = true;
    });
    builder.addCase(getUserDetailsInfo.rejected, (state, action) => {
      state.manageAccount = "";
      state.listOfUserLoder = false;
      state.listOfUserError = action.error;
      state.userListRetryCount += 1;
      if (shouldStopApiRetry(state.userListRetryCount)) {
        state.userListFetched = true;
        logApiRetryCapDwLog(
          EC_DW_LOGGING_STEPS.getaccount_by_cusid_API_retry_cap,
          action.error?.message
        );
      }
    });

    builder.addCase(getAccountDetailsInfo.pending, (state) => {
      state.loading = true;
      state.isGetAccountDetailsLoading = true;
      state.data = null;
    });
    builder.addCase(getAccountDetailsInfo.fulfilled, (state, action) => {
      state.data = action.payload;
      state.acp = action?.payload?.acp?.toLowerCase();
      state.loading = false;
      state.error = null;
      state.isGetAccountDetailsLoading = false;
      state.accountDetailsRetryCount = 0;
      state.accountDetailsFetched = true;
    });
    builder.addCase(getAccountDetailsInfo.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "user details",
        action.error?.message,
        action?.type
      );
      state.data = null;
      state.loading = false;
      state.error = action.error;
      state.isGetAccountDetailsLoading = false;
      state.accountDetailsRetryCount += 1;
      if (shouldStopApiRetry(state.accountDetailsRetryCount)) {
        state.accountDetailsFetched = true;
        logApiRetryCapDwLog(
          EC_DW_LOGGING_STEPS.getaccount_by_ban_API_retry_cap,
          action.error?.message
        );
      }
    });

    builder.addCase(createSecurityPin.pending, (state) => {
      state.createPinLoading = true;
      state.createPinError = null;
    });
    builder.addCase(createSecurityPin.fulfilled, (state, action) => {
      state.createPinLoading = false;
      const isPinCreateSuccessful = action.payload?.success === true;
      state.createPinError = isPinCreateSuccessful
        ? null
        : action.payload?.message || "Unable to create security PIN";
      if (!state.data) {
        state.data = {};
      }
      if (isPinCreateSuccessful) {
        state.data.accountPinExists = true;
        state.data.hasSecurityPin = true;
      }
    });
    builder.addCase(createSecurityPin.rejected, (state, action) => {
      state.createPinLoading = false;
      state.createPinError = (action.payload as string) || action.error?.message || "Unable to create security PIN";
    });
  },
});

export const {
  setAcpStatus,
  setAcpModalStatus,
  addToken,
  logout,
  addClientId,
  removeClientId,
  addJwtTokens,
  addRefreshTokens,
  startLoading,
  stopLoading,
  addFirstTimeSetPasswordAccountEnabled,
  addPrincipalName,
  removePrincipalName,
  addCompanyName,
  removeCompanyName,
  addChangePassClientId,
  removeChangePassClientId,
  addOTP,
  setPrefMethod,
  setCanUserResetPass,
  addAccountIdForRegisterOnly,
  addEmailForRegisterOnly,
  setContactNumber,
  setIsCaptchaChecked,
  addRootToken,
  startCaptchaLoading,
  stopCaptchaLoading,
  addForgotEmailId,
  setAppDownloadModalHideAsDoNotShowAgain,
  setReOpenAppDownloadModal,
  addEmailBeforeLogin,
  addUserNameBeforeLogin,
  isCtlUserBeforeLogin,
  setIsUserSettingPassFromEmailLink,
  setIsSilentLogin,
  setOriginalPrimaryEmail,
  addEmailPhoneForOtp,
  setAutoPayEnrolled,
  addUserCustomerId,
  logoutClicked,
  addUserDetails,
  switchUserStart,
  switchUserStop,
  setUserLockStatus,
  addEmailHash_ForRegisterOnly,
  addPhoneNoHash,
  updateLastLoginUserBan,
  updateLastLoginUserAddressId,
  updateForgetPassPayloadForResendOTP,
  setManageAccount,
  setAddUserForRegisterAz,
  addUserName,
  addForgetUserNameContactNumber,
  updateFlowType,
  clearSession,
  syncSessionId,
  setGrandfather,
  updateCommPrefData,
  setMigrationDslEligible,
  setMigrationVoiceEligible,
  setMigrationNoVoiceEligible,
  setIsUserOnJeopardy,
  setSecurityPin,
} = userSlice.actions;
export default userSlice.reducer;
